/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../../../common";
import type {
  MoarMintable,
  MoarMintableInterface,
} from "../../../../../../contracts/submodules/moar-locker/contracts/mock/MoarMintable";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "authority",
        type: "address",
      },
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        internalType: "address",
        name: "royaltyAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalToOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error",
  },
  {
    inputs: [],
    name: "BurnningInactive",
    type: "error",
  },
  {
    inputs: [],
    name: "ContractBidder",
    type: "error",
  },
  {
    inputs: [],
    name: "DuplicatedMint",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedAuctionSupply",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedDiamondHandSupply",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedMaxSupply",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedMaxTicket",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPayment",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSaleOn",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSignature",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTime",
    type: "error",
  },
  {
    inputs: [],
    name: "MetadataFrozen",
    type: "error",
  },
  {
    inputs: [],
    name: "NonAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "NonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "NonExistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "RoyaltyPercentageExceed",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferDeactive",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLocked",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLockedByAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "WithdrawFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "LockTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "refundFailed",
    type: "event",
  },
  {
    inputs: [],
    name: "DHDAMaxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DHDATotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DIAMOND_HAND_ID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_DROP_INTERVAL",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_DROP_PER_STEP",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_END_PRICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_MAX_TICKET",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_PRICE_CURVE_LENGTH",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_START_PRICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burningActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tierIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierStartTimes",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierDurations",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierMaxTicketNums",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierTicketPrices",
        type: "uint256[]",
      },
    ],
    name: "configSales",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "diamondHandMaxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketNum",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "diamondHandMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketNum",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "dutchAuctionMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "dutchAuctionPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dutchAuctionStartTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "lockTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bool[]",
        name: "locks",
        type: "bool[]",
      },
    ],
    name: "lockTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "metadataFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tos",
        type: "address[]",
      },
    ],
    name: "privateMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "provenance",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "publicMints",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "saleOn",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "authority",
        type: "address",
      },
    ],
    name: "setAuthority",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
    ],
    name: "setDutchAuctionStartTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "provenance_",
        type: "bytes32",
      },
    ],
    name: "setProvenance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tiers",
    outputs: [
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxTicketNum",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ticketPrice",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "flag",
        type: "uint256",
      },
    ],
    name: "toggleFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "transferDeactive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transferLocks",
    outputs: [
      {
        internalType: "enum MoarBase.LockStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tierId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ticketNum",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "whitelistMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type MoarMintableConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MoarMintableConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MoarMintable__factory extends ContractFactory {
  constructor(...args: MoarMintableConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    authority: PromiseOrValue<string>,
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<MoarMintable> {
    return super.deploy(
      authority,
      admin,
      royaltyAddress,
      overrides || {}
    ) as Promise<MoarMintable>;
  }
  override getDeployTransaction(
    authority: PromiseOrValue<string>,
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      authority,
      admin,
      royaltyAddress,
      overrides || {}
    );
  }
  override attach(address: string): MoarMintable {
    return super.attach(address) as MoarMintable;
  }
  override connect(signer: Signer): MoarMintable__factory {
    return super.connect(signer) as MoarMintable__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MoarMintableInterface {
    return new utils.Interface(_abi) as MoarMintableInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MoarMintable {
    return new Contract(address, _abi, signerOrProvider) as MoarMintable;
  }
}
